var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "login"
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticClass: "login-container",
    attrs: {
      model: _vm.ruleForm,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "auto"
    }
  }, [_c("h2", [_vm._v(_vm._s(_vm.config.title))]), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("common.username"),
      prop: "username"
    }
  }, [_c("el-input", {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: _vm.ruleForm.username,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "username", $$v);
      },
      expression: "ruleForm.username"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("common.password"),
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      type: "Password",
      "auto-complete": "off",
      "show-password": ""
    },
    model: {
      value: _vm.ruleForm.password,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v);
      },
      expression: "ruleForm.password"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 16
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("common.captcha"),
      prop: "captcha"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.ruleForm.captcha,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "captcha", $$v);
      },
      expression: "ruleForm.captcha"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-image", {
    staticStyle: {
      "max-width": "100%",
      width: "140px",
      height: "30px"
    },
    attrs: {
      src: _vm.capImg
    },
    on: {
      click: function click($event) {
        return _vm.roundCap();
      }
    }
  })], 1), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading,
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.submitForm("ruleForm");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.login")) + " ")]), _c("el-button", {
    attrs: {
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.resetForm("ruleForm");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.reset")))])], 1)], 1)], 1), _c("verify-twofa", {
    ref: "verify2fa",
    on: {
      "login-success": _vm.loginSuccess
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };